module.exports = __webpack_public_path__ + "static/img/cocina_09.90858e32.jpeg";